<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
========================================================================================== -->

<template>
<div id="teleCommande">
    <vs-popup fullscreen title="Liste Des Articles" :active.sync="popupActive">

        <div class="flex flex-wrap justify-between items-center">

            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                            <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                            <span>150</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
            </div>
        </div>
        <div style="margin-bottom: 30px;margin-top: 30px;">
            <ag-grid-vue style="height:68vh" @grid-ready="onGridReady" :pagination="true" :paginationPageSize="paginationPageSize" ref="agGridTable" class="ag-theme-material w-100 ag-grid-table" @row-double-clicked="onArticleChecked" rowSelection="single" :gridOptions="gridOptions" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="usersData">
            </ag-grid-vue>
        </div>

        <!-- <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" /> -->

    </vs-popup>

    <div class="vx-card" v-if="$store.state.AppActiveUser.username != 'cogepha'">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>{{$store.state.AppActiveUser.societe.nom}}</h4>
            </div>
        </div>
        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <div class="flex mb-12">
                    <div class="w-1/3 bg-grid-color-secondary h-12 px-2">
                        <div class="w-full mt-4">
                            <label class="block text-gray-700 text-sm font-bold mb-2">Code client</label>

                            <div class="mt-2">
                                <vs-input class="w-full" v-model="id_user" icon-pack="feather" icon="icon-info" />
                                <!--<vs-input readonly class="w-full" v-model="id_user" icon-pack="feather" icon="icon-info" />-->
                            </div>
                        </div>
                    </div>
                    <div class="w-1/3 bg-grid-color h-12 px-2">
                        <div class="w-full mt-4">
                            <label class="block text-gray-700 text-sm font-bold mb-2">Type de commande</label>

                            <div class="mt-2">
                                <v-select readonly class="w-full" v-model="selected" :options="options" />

                                <span class="text-danger text-sm" v-show="errors.has('pays')">{{ errors.first('pays') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="w-1/3 bg-grid-color-secondary h-12 px-2">
                        <div class="w-full mt-4">
                            <label class="block text-gray-700 text-sm font-bold mb-2">Date</label>

                            <div class="mt-2">
                                <vs-input readonly class="w-full" v-model="DateCourant" icon-pack="feather" icon="icon-info" />

                                <span class="text-danger text-sm" v-show="errors.has('nom')">{{ errors.first('nom') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex mb-12">
                    <div class="w-5/6 h-12 px-2">
                        <div class="vx-row">
                            <!--<div class="vx-col md:w-1/3 w-full">
                                <div class="w-full mt-4">
                                    <label class="block text-gray-700 text-sm font-bold mb-2">Crédit autorisé</label>

                                    <div class="mt-2">
                                        <vs-input readonly class="w-full" v-model="CreditA" icon-pack="feather" icon="icon-info" />

                                        <span class="text-danger text-sm" v-show="errors.has('nom')">{{ errors.first('nom') }}</span>
                                    </div>
                                </div>
                            </div>-->

                            <!--<div class="vx-col md:w-1/3 w-full">
                                <div class="w-full mt-4">
                                    <label class="block text-gray-700 text-sm font-bold mb-2">Magasin</label>

                                    <div class="mt-2">
                                        <vs-input readonly v-model="Magazin" class="w-full" icon-pack="feather" icon="icon-info" />

                                        <span class="text-danger text-sm" v-show="errors.has('pays')">{{ errors.first('pays') }}</span>
                                    </div>
                                </div>
                            </div>-->

                            <div class="vx-col md:w-1/3 w-full">
                                <div class="w-full mt-4">
                                    <label class="block text-gray-700 text-sm font-bold mb-2">Heure de livraison</label>

                                    <div class="mt-2">
                                        <flat-pickr class="w-full" :config="configdateTimePicker" v-model="DateLivraison" />

                                        <span class="text-danger text-sm" v-show="errors.has('pays')">{{ errors.first('pays') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-1/6 bg-gray-400 h-12 px-2">
                        <div class="vx-row">
                            <!--<div class="vx-col w-full">
                                <div class="w-full mt-4">
                                    <label class="block text-gray-700 text-sm font-bold mb-2">Date de facturation</label>

                                    <div class="mt-4">
                                        <vs-checkbox v-model="decalage">Commande à décaler</vs-checkbox>
                                    </div>
                                </div>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <vs-collapse class="vx-card" v-else>
        <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevrons-down" :open="true">
            <!-- <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 v-if="$store.state.AppActiveUser.username != 'cogepha'" class>{{$store.state.AppActiveUser.societe.nom}}</h4>
            </div>
        </div> -->
            <div class="vs-con-loading__container">
                <div class=" ">
                    <div class="flex mb-4">
                        <div class="vx-col md:w-1/3  sm:w-1/2 w-full bg-grid-color-secondary  px-2">
                            <div class="  ">
                                <label class="block text-gray-700 text-sm font-bold mb-2">Code client</label>
                                <div class="mt-2">
                                    <vs-input v-if="$store.state.AppActiveUser.username != 'cogepha'" readonly class="w-full " v-model="id_user" icon-pack="feather" icon="icon-info" />
                                    <v-select v-else readonly ref="trabelsi" class="w-full" label="Name" value="No" v-model="selectedClient" :options="optionsClients" />
                                </div>
                                <!--<div class="mt-2">
                                    <vs-input v-if="$store.state.AppActiveUser.username != 'cogepha'" readonly class="w-full " v-model="id_user" icon-pack="feather" icon="icon-info" />
                                    <v-select v-else readonly ref="trabelsi" class="w-full" label="Name" value="No" v-model="selectedClient" :options="optionsClients" />
                                </div>-->
                            </div>
                        </div>

                        <div class="md:w-1/3  sm:w-1/2  bg-grid-color-secondary  px-2" v-if="$store.state.AppActiveUser.username == 'cogepha'">
                            <div class="">
                                <label class="block text-gray-700 text-sm font-bold mb-2">Télèphone </label>

                                <div class="mt-2">
                                    <vs-input readonly v-model="Telephone" class="w-full" icon-pack="feather" icon="icon-phone" />
                                </div>
                            </div>
                        </div>
                        <div class="md:w-1/3 sm:w-1/2 bg-grid-color-secondary  px-2">
                            <div class=" ">
                                <label class="block text-gray-700 text-sm font-bold mb-2">Crédit autorisé</label>

                                <div class="mt-2">
                                    <vs-input readonly class="w-full" v-model="CreditA" icon-pack="feather" icon="icon-dollar-sign" />

                                    <span class="text-danger text-sm" v-show="errors.has('nom')">{{ errors.first('nom') }}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="flex mb-4">

                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Magasin</label>

                                <div class="mt-2">
                                    <vs-input readonly v-model="Magazin" class="w-full" icon-pack="feather" icon="icon-home" />

                                    <span class="text-danger text-sm" v-show="errors.has('pays')">{{ errors.first('pays') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Type de commande</label>

                                <div class="mt-2">
                                    <v-select readonly class="w-full" v-model="selected" :options="options" />

                                    <span class="text-danger text-sm" v-show="errors.has('pays')">{{ errors.first('pays') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Date</label>

                                <div class="mt-2">
                                    <vs-input readonly class="w-full" v-model="DateCourant" icon-pack="feather" icon="icon-clock" />

                                    <span class="text-danger text-sm" v-show="errors.has('nom')">{{ errors.first('nom') }}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="flex mb-1">

                        <div class="vx-col md:w-1/3 w-full sm:w-1/2 bg-grid-color-secondary px-2">
                            <div class="w-full  ">
                                <label class="block text-gray-700 text-sm font-bold mb-2">Heure de livraison</label>

                                <div class="mt-1">
                                    <flat-pickr class="w-full" :config="configdateTimePicker" v-model="DateLivraison" />

                                    <span class="text-danger text-sm" v-show="errors.has('pays')">{{ errors.first('pays') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary px-2">
                            <div class="w-full  ">
                                <label class="block text-gray-700 text-sm font-bold mb-2">Observation </label>

                                <div class="  mt-1">
                                    <vs-input readonly class="w-full" icon-pack="feather" icon="icon-book" />
                                </div>
                            </div>

                        </div>
                        <div class="vx-col md:w-1/3 sm:w-1/2  w-full bg-grid-color-secondary px-2">
                            <div class="w-full  ">
                                <label class="block text-gray-700 text-sm font-bold mb-2">Date de facturation</label>

                                <div class="ml-20 mt-4  ">
                                    <vs-checkbox v-model="decalage">Commande à décaler</vs-checkbox>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </vs-collapse-item>

    </vs-collapse>

    <div></div>

    <br />

    <div class="vx-card p-6">
        <div id="app">

            <div class="vx-row">
                <div class="vx-col md:w-2/12 w-full">
                </div>
                <div class="vx-col md:w-7/12 w-full">
                    <vue-search class="Recherche" :list="simpleSuggestionList" :max-suggestions="1000" :filter-by-query="true" :min-length="2" ref="Recherche" placeholder="Recherche avec : désignation ..." @select="onArticleChecked" @request-done="onRequestDone" @hide-list="onHideList" value-attribute="code" display-attribute="designation">

                        <template slot="misc-item-above" slot-scope="{ suggestions }">
                            <template v-if="suggestions.length > 0">
                                <div class="misc-item">
                                    <span>{{ suggestions.length }} suggestions sont affichées....</span>
                                </div>
                                <hr>
                            </template>

                            <div class="misc-item" v-else-if="!loading">
                                <span>Pas de résultas</span>
                            </div>
                        </template>

                        <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.description">
                            <div class="text">
                                <span v-html="boldenSuggestion(scope)"></span>
                            </div>
                            <!-- <button @click.stop="goto(scope.suggestion.link)">Voir plus..</button> -->
                        </div>

                        <div class="misc-item" slot="misc-item-below" slot-scope="" v-if="loading">
                            <span>Chargement...</span>
                        </div>

                    </vue-search>
                </div>
                <div class="vx-col md:w-3/12 w-full">
                    <vs-button color="primary" type="border" @click="OpenModal()" icon-pack="feather" icon="icon-search"></vs-button>
                </div>
            </div>

        </div>
        <vs-table ref="table" :data="commandes" hoverFlat>

            <template slot="thead">
                <vs-th class="w-0/12"></vs-th>
                <vs-th class="w-2/12"> Code article</vs-th>
                <vs-th class="w-4/12"> Désignation</vs-th>
                <vs-th class="w-2/12"> Quantité</vs-th>
                <vs-th class="text-center w-2/12"> Prix</vs-th>
                <vs-th class="w-2/12"> Totale</vs-th>
                <vs-th class="w-0/12"></vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td class="text-center">
                            <vs-button size="small" v-if="data[indextr].valide == true" radius color="primary" type="gradient" icon-pack="feather" icon="icon-check"></vs-button>
                            <vs-button size="small" v-else radius color="danger" type="gradient" icon-pack="feather" icon="icon-x"></vs-button>
                        </vs-td>
                        <!-- <vs-td class="text-center EditableField" contenteditable='true' :ref="'code-'+indextr" @keyup.enter.native="OpenModal(indextr)" @click="OpenModal(indextr)" readonly> -->
                        <!-- <vs-button color="primary" type="border" icon-pack="feather" icon="icon-search"></vs-button> -->
                        <!-- <vs-td class="text-center" :ref="'code-'+indextr" @keyup.enter.native="OpenModal(indextr)" @click="OpenModal(indextr)" readonly>
                            <vs-input size="small" :ref="'code-'+indextr" @keyup.enter.native="OpenModal(indextr)" @click="OpenModal(indextr)" v-model="data[indextr].code" class="w-full" readonly />
                        </vs-td> -->
                        <vs-td :ref="'code-'+indextr" class="text-center">{{data[indextr].code}}</vs-td>
                        <vs-td class="text-center">{{data[indextr].designation}}</vs-td>
                        <vs-td class="text-center">
                            <vs-input size="small" ref="qte" @keyup="ValiderQte($event,indextr)" @focus="onFocusQte" v-model="data[indextr].qte" class="w-full qteclass" :disabled="data[indextr].disabled" />
                        </vs-td>
                        <vs-td class="text-center">{{data[indextr].prix}}</vs-td>
                        <vs-td class="text-center">{{data[indextr].totale}}</vs-td>
                        <vs-td class="text-center">
                            <vs-button size="small" radius color="danger" type="gradient" icon-pack="feather" icon="icon-trash" @click="deleteData(indextr)"></vs-button>
                        </vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-td class="different"></vs-td>
                        <vs-td class="different"></vs-td>
                        <vs-td class="different"></vs-td>
                        <vs-td class="different"></vs-td>
                        <vs-td class="different"></vs-td>
                        <vs-td class="text-center xl:font-black diff">{{totalePrix}}</vs-td>
                        <vs-td class="different"></vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>

        <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button ref="loadableButton" id="button-with-loading" type="relief" @click="popupActivee=true" color="primary" class="ml-auto mt-2 vs-con-loading__container" :disabled="validateAddArticle">Passer la commande</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Initialiser</vs-button>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-popup style="width:100%" id="ConfirmationPopup" class="holamundo" title="Confirmation commande" :active.sync="popupActivee">
                        <table style="width:100%" class="border-collapse">
                            <tr>
                                <th class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-3/6 w-full">Article</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-1/6 w-full text-center">Quantité</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-1/6 w-full text-center">Prix</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-1/6 w-full text-center">Totale</th>
                            </tr>
                            <tr :key="indextr" v-for="(tr, indextr) in commandes">
                                <td v-if="commandes[indextr].code != ''" class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-3/6 w-full">{{commandes[indextr].designation}}</td>
                                <td v-if="commandes[indextr].code != ''" class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-1/6 w-full text-center">{{commandes[indextr].qte}}</td>
                                <td v-if="commandes[indextr].code != ''" class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-1/6 w-full text-center">{{commandes[indextr].prix}}</td>
                                <td v-if="commandes[indextr].code != ''" class="p-2 border border-solid d-theme-border-grey-light vx-col md:w-1/6 w-full text-center">{{commandes[indextr].totale}}</td>
                            </tr>
                        </table>

                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <div class="mt-8 flex flex-wrap items-center justify-end">
                                    <vs-button color="primary" type="gradient" @click="getIdbyCode()">Confirmer</vs-button>
                                </div>
                            </div>
                        </div>
                    </vs-popup>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import {
    AgGridVue
} from "ag-grid-vue";

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import "vue-simple-suggest/dist/styles.css";
import Prism from "vue-prism-component";
import index from "../../http/requests/article/index.js";
import indexCommande from "../../http/requests/commande/index.js";
import VueSearch from "./search/vue-simple-suggest.vue";
import clientService from "@/http/requests/client/index.js"
export default {
    name: "Autocomplete",
    components: {
        "v-select": vSelect,
        flatPickr,
        AgGridVue,
        VueSearch,
        Prism
    },
    data() {
        return {
            ClientData:null,
            idClientCommande:'',
            loading: false,
            decalage: false,
            selectedClient: {},
            popupActivee: false,
            SelectedRow: 0,
            maxPageNumbers: 7,
            paginationPageSize: 20,
            searchQuery: "",
            // AgGrid
            gridApi: null,
            gridOptions: {
                rowSelection: "single"
            },
            defaultColDef: {
                sortable: true,
                resizable: true,
                filter: true
            },
            columnDefs: [{
                    headerName: "Code",
                    field: "code",
                    cellStyle: {
                        color: 'black'
                    }
                },
                {
                    headerName: "Désignation",
                    field: "designation",
                    suppressSizeToFit: true,
                    cellStyle: {
                        color: 'black'
                    }
                },
                {
                    headerName: "Fournisseur",
                    field: "fournisseur",
                    cellStyle: {
                        color: 'black'
                    }
                },
                {
                    headerName: "Cathégorie",
                    field: "categorie",
                    cellStyle: {
                        color: 'black'
                    }
                },
                {
                    headerName: "Classe",
                    field: "classe",
                    cellStyle: {
                        color: 'black'
                    }
                },
                {
                    headerName: "Dci1",
                    field: "dci1",
                },
                {
                    headerName: "Dci2",
                    field: "dci2",
                    cellStyle: {
                        color: 'black'
                    }
                }
            ],
            DateCourant: "",
            DateLivraison: "",
            configdateTimePicker: {
                enableTime: true,
                dateFormat: "d-m-Y H:i"
            },
            options: [{
                    id: "Urgent",
                    label: "Urgente"
                },
                {
                    id: "Ordinary",
                    label: "Ordinaire"
                },
                {
                    id: "Grouped",
                    label: "Groupée"
                }
            ],
            selected: {
                id: "Ordinary",
                label: "Ordinaire"
            },
            commandes: [{
                code: "",
                designation: "",
                qte: "",
                prix: "",
                totale: "",
                disabled: true,
                valide: false
            }],
            popupActive: false,
            Telephone: "",
            id_user: "",
            requestedSearch: []
        };
    },
    computed: {
        validateForm() {
            if (
                parseFloat(
                    this.commandes[this.commandes.length - 1].qte.replace(",", ".")
                ) > 0
            )
                return true;
            else return false;
        },
        validateAddArticle() {
            if (this.commandes[0].disabled)
                return true
            var test = false;
            this.commandes.forEach(function (item) {
                if (!item.disabled)
                    if (!item.valide) {
                        test = true;
                        return;
                    }
            });
            return test;
        },
        totalePrix() {
            return (
                this.commandes.reduce((a, b) => +a + +b.totale, 0).toFixed(3) + " DT"
            );
        },
        usersData() {
            return this.$store.state.article.articles;
        },
        optionsClients() {
            // this.$vs.loading();
            // if (this.$store.state.article.clients.length > 0)
            //     this.$vs.loading.close();
            return this.$store.state.article.clients.value;
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
            }
        }
    },
    watch: {
        selectedClient: function (val) {
            try {
                this.Telephone = val.Phone_No,
                this.id_user = val.No;
                this.$refs["Recherche"].$el.querySelector("input").focus();
                this.commandes = [{
                    code: "",
                    designation: "",
                    qte: "",
                    prix: "",
                    totale: "",
                    disabled: true,
                    valide: false
                }];
            } catch {
                this.id_user = "";
            }
        }
    },
    methods: {
        getIdbyCode(){
            console.log("this.id_user : ",this.id_user);
                 try {
                    clientService.getClient(this.id_user).then((response) => {
                    this.ClientData =  response.data;
                    this.idClientCommande = this.ClientData.id;
                    console.log("idClientCommande = ", this.idClientCommande);   
                    this.Commander();        
                });
                } catch {
                    this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération du client",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles",
                });
                }
        }, 
        onGridReady(params) {
            this.gridColumnApi.setColumnWidth('code', this.columnWidth(11));
            this.gridColumnApi.setColumnWidth('designation', this.columnWidth(34));
            this.gridColumnApi.setColumnWidth('fournisseur', this.columnWidth(11));
            this.gridColumnApi.setColumnWidth('categorie', this.columnWidth(11));
            this.gridColumnApi.setColumnWidth('classe', this.columnWidth(11));
            this.gridColumnApi.setColumnWidth('dci1', this.columnWidth(11));
            this.gridColumnApi.setColumnWidth('dci2', this.columnWidth(11));
            params.api.sizeColumnsToFit();
        },
        columnWidth: function (percentage) {
            var width = (window.innerWidth - 100) * percentage / 100; // Pixel calculation
            return width;
        },
        onFocusQte() {
            this.$nextTick(function () {
                this.$refs["Recherche"].text = "";
                this.$refs["Recherche"].selected = null;
            });
        },
        reset_data() {
            this.LoadDateSession();
            this.commandes = [{
                code: "",
                designation: "",
                qte: "",
                prix: "",
                totale: "",
                disabled: true,
                valide: false
            }, ];
            this.selected = {
                id: 'Ordinary',
                label: 'Ordinaire'
            };
            this.decalage = false;
            if (this.$store.state.AppActiveUser.id == 0) {
                this.selectedClient = [];
            }
            this.SelectedRow = 0;
        },
        simpleSuggestionList() {
            return JSON.parse(JSON.stringify(this.$store.state.article.articles));
            // var names = this.$store.state.article.articles.map(function (item) {
            //     return item['designation'];
            // });
            // return names
        },
        boldenSuggestion(scope) {
            if (!scope) return scope;
            const {
                suggestion,
                query
            } = scope;
            let result = this.$refs.Recherche.displayProperty(suggestion);
            if (!query) return result;
            const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [''];
            return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'), '$1<b>$2</b>$3');
        },
        /*  goto(url) {
             console.log(url)
         }, */
        onRequestStart() {
            this.loading = true
        },
        onRequestDone(e) {
            this.loading = false
            this.$refs["Recherche"].hovered = e[0];
        },
        onRequestFailed() {
            this.loading = false
        },
        onShowList() {},
        LoadDateSession() {
            var today = new Date(Date.now());
            var dd = String(today.getDate()).padStart(2, "0");
            var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = today.getFullYear();
            var time =
                today.getHours() +
                ":" +
                String(today.getMinutes()).padStart(2, "0") +
                ":" +
                today.getSeconds();
            today = dd + "-" + mm + "-" + yyyy + " " + time;
            this.DateCourant = today;
            this.DateLivraison = null;
        },
        LoadData() {
            //this.$vs.loading();
            this.selectedClient = {
                    No: this.id_user,
            }
        },
        Commander() {
            this.popupActivee = false;
            this.$vs.loading();
            this.$vs.loading({
                background: this.backgroundLoading,
                color: this.colorLoading,
                container: "#button-with-loading",
                scale: 0.45
            });

            for (var i = 0; i < this.commandes.length; i++) {
                if (this.commandes[i].disabled == true)
                    this.commandes.splice(i, 1)
            }
            let ligne_commande = this.commandes.map(function (obj) {
                return {
                    code: obj.code,
                    quantite: obj.qte
                };
            });

            // ligne_commande.length = ligne_commande.length - 1;
            const commande = {
                type: this.selected.id,
                dateLivraisonPrevu: this.DateLivraison,
                dateSession: this.DateCourant,
                idClient: this.id_user,
                //magasin: this.Magazin,
                montant: this.totalePrix.substring(0, this.totalePrix.length - 2),
                //decalage: this.decalage,
                ligne_commande: ligne_commande
            };
            indexCommande
                .Commander(this.idClientCommande, commande)
                .then(() => {

                    this.$vs.loading.close();
                    this.$vs.loading.close("#button-with-loading > .con-vs-loading");
                    this.LoadDateSession();
                    this.commandes = [{
                        code: "",
                        designation: "",
                        qte: "",
                        prix: "",
                        totale: "",
                        disabled: true,
                        valide: false
                    }, ];
                    this.selected = {
                        id: 'Ordinary',
                        label: 'Ordinaire'
                    };
                    this.decalage = false;
                    if (this.$store.state.AppActiveUser.id == 0) {
                        this.selectedClient = [];
                    }
                    this.idClientCommande = null; 
                    this.SelectedRow = 0;

                    this.$vs.notify({
                        time: 10000,
                        title: "Enregistrement avec succès",
                        text: "La commande que vous saisie a été enregistrée avec succès !",
                        color: "primary",
                        iconPack: "feather",
                        icon: "icon-check",
                        position: "top-right"
                    });
                    this.$vs.loading.close();
                    this.$vs.loading.close("#button-with-loading > .con-vs-loading");

                })
                .catch(error => {
                    this.LoadDateSession();

                    this.$vs.loading.close();
                    this.$vs.loading.close("#button-with-loading > .con-vs-loading");
                    if (error.response.status == '400') {

                        this.$vs.notify({
                            time: 10000,
                            title: "Erreur s'est produite",
                            text: error.response.data.commande,
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-alert-circles"
                        });
                    } else if (error.response.status == '401') {

                        this.$vs.notify({
                            time: 10000,
                            title: "Erreur s'est produite",
                            text: error.response.data.commande,
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-alert-circles"
                        });
                    } else if (error.response.status == '402') {
                        let arr = Object.values(error.response.data);
                        arr = arr.filter(function (el) {
                            return el.statuscode == 400;
                        });
                        arr.forEach(myObject => {
                            for (var i = 0; i < this.commandes.length; i++) {
                                if (this.commandes[i].code == myObject.Item_No) {
                                    this.commandes[i].valide = false
                                    break;
                                }
                            }
                        });
                        arr.forEach(myObject => {
                            this.$vs.notify({
                                time: 10000,
                                title: "erreur s'est produite",
                                text: "Stock indisponible pour l'article de code : " + myObject.Item_No,
                                color: "danger",
                                iconPack: "feather",
                                icon: "icon-alert-circles",
                            });
                        });
                    }
                });
        },
        deleteData(indextr) {
            if (this.commandes.length == 1) {
                this.commandes = [{
                    code: "",
                    designation: "",
                    qte: "",
                    prix: "",
                    totale: "",
                    disabled: true,
                    valide: false
                }]
                return;
            }
            this.commandes.splice(indextr, 1);
            this.SelectedRow = this.commandes.length - 1;

        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        onHideList() {
            // this.$nextTick(function () {
            //     this.$refs["Recherche"].text = "";
            //     this.$refs["Recherche"].selected = null;
            // });
        },
        togglePickerr() {},
        articleExists(code) {
            return this.commandes.some(function (el) {
                return el.code === code;
            });
        },
        findWithAttr(attr, value) {
            for (var i = 0; i < this.commandes.length; i += 1) {
                if (this.commandes[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        },
        onArticleChecked(selected) {
            if (selected.type === "rowDoubleClicked") {
                console.log(this.gridOptions.api.getSelectedRows()[0])
                var selectedCommande = (selectedCommande = this.gridOptions.api.getSelectedRows()[0]);
                if (this.articleExists(selectedCommande.code)) {
                    console.log('2')
                    var indexCode = this.findWithAttr('code', selectedCommande.code);
                    this.commandes[indexCode].code = selectedCommande.code;
                    this.commandes[indexCode].designation = selectedCommande.designation;
                    this.popupActive = false;
                    this.commandes[indexCode].disabled = false;
                    this.commandes[indexCode].qte = "";
                    this.commandes[indexCode].valide = false;
                    // this.$nextTick(function () {
                    //     this.$refs["qte"][indexCode].$el.querySelector("input").focus();
                    // });
                    this.$nextTick(function () {
                        this.$refs["qte"][indexCode].$el.querySelector("input").focus();
                        this.SelectedRow = indexCode;
                    });
                } else {
                    console.log(this.commandes.length - 1)
                    this.commandes[this.commandes.length - 1].code = selectedCommande.code;
                    this.commandes[this.commandes.length - 1].designation = selectedCommande.designation;
                    this.popupActive = false;
                    this.commandes[this.commandes.length - 1].disabled = false;
                    this.commandes[this.commandes.length - 1].qte = "";
                    this.commandes[this.commandes.length - 1].valide = false;
                    // this.$refs["qte"][this.commandes.length - 1].$el.querySelector("input").focus();
                    this.$nextTick(function () {
                        this.$refs["qte"][this.commandes.length - 1].$el.querySelector("input").focus();
                        this.SelectedRow = this.commandes.length - 1;
                    });
                    // this.$nextTick(function () {
                    //     this.$refs["qte"][this.SelectedRow].$el.querySelector("input").focus();
                    // });
                }

            } else {
                var selectedCommandee = selected;
                if (this.articleExists(selectedCommandee.code)) {
                    var indexCodeee = this.findWithAttr('code', selectedCommandee.code);
                    this.commandes[indexCodeee].code = selectedCommandee.code;
                    this.commandes[indexCodeee].designation = selectedCommandee.designation;
                    this.commandes[indexCodeee].disabled = false;
                    this.commandes[indexCodeee].qte = "";
                    this.commandes[indexCodeee].valide = false;
                    this.$nextTick(function () {
                        this.$refs["qte"][indexCodeee].$el.querySelector("input").focus();
                        this.SelectedRow = indexCodeee;
                    });
                } else {
                    if ((this.commandes[this.commandes.length - 1].disabled) || (!this.commandes[this.commandes.length - 1].valide)) {
                        // || (this.commandes[this.commandes.length - 1].qte == 0)|| (this.commandes[this.commandes.length - 1].qte == "")) {
                        this.commandes[this.commandes.length - 1].code = selectedCommandee.code;
                        this.commandes[this.commandes.length - 1].designation = selectedCommandee.designation;
                        this.commandes[this.commandes.length - 1].disabled = false;
                        this.commandes[this.commandes.length - 1].qte = "";
                        this.commandes[this.commandes.length - 1].valide = false;
                    } else {
                        this.commandes.push({
                            code: selectedCommandee.code,
                            designation: selectedCommandee.designation,
                            qte: "",
                            prix: "",
                            totale: "",
                            disabled: false,
                            valide: false
                        });
                    }
                    this.$nextTick(function () {
                        this.$refs["qte"][this.commandes.length - 1].$el.querySelector("input").focus();
                        this.SelectedRow = this.commandes.length - 1;
                    });
                }
            }
        },
        OpenModal() {
            this.popupActive = true;
            // this.SelectedRow = indextr;
        },
        ValiderQte(e, indextr) {
            this.selectedClient.No = this.id_user;
            this.commandes[indextr].valide = false;
            this.SelectedRow = indextr;
            if (e.keyCode === 13 || e.type === "click") {

                if (isNaN(this.commandes[indextr].qte)) {
                    this.$vs.notify({
                        time: 10000,
                        title: "Quantité invalide !",
                        text: "Tu doit mettre une quantité valide",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circles"
                    });
                    this.commandes[indextr].qte = "";
                    return;
                }
                if (this.commandes[indextr].qte == 0) {
                    // this.$vs.notify({
                    //     time: 10000,
                    //     title: "Quantité invalide !",
                    //     text: "Tu doit mettre une quantité > 0",
                    //     color: "danger",
                    //     iconPack: "feather",
                    //     icon: "icon-alert-circles"
                    // });
                    return;
                }

                if (this.selectedClient == null) {
                    this.$vs.notify({
                        time: 10000,
                        title: 'Client introuvable !',
                        text: 'Tu doit sélectionner un client',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circles',
                    })
                    return;
                }

                this.$vs.loading();
                index
                    .GetStock(
                        this.commandes[indextr].code,
                        this.selectedClient.No,
                        this.commandes[indextr].qte
                    )
                    .then(response => {
                        console.log(response)
                        this.$vs.loading.close();
                        try {
                            if (response.data.Quantity_available != null) {
                                if (response.data.Quantity_available > 0) {
                                    this.commandes[indextr].prix = response.data.Unit_Price;
                                    if (this.commandes[indextr].qte <= response.data.Quantity_available) {
                                        if (response.data.Promotion_Inventory != 0 && response.data.Promotion_Exist == true) {
                                            if (response.data.Sales_threshold > this.commandes[indextr].qte) {
                                                this.$vs.dialog({
                                                    type: "confirm",
                                                    color: "primary",
                                                    title: `Promotion`,
                                                    text: "Une promotion est disponible pour l'article " +
                                                        this.commandes[indextr].code +
                                                        " avec un seuil d'achat " +
                                                        response.data.Sales_threshold +
                                                        ", voulez vous changer la quatité pour pouvoir bénéficier de la promotion : " +
                                                        response.data.Sales_threshold +
                                                        " ---> " +
                                                        response.data.Free_Sales_Qty,
                                                    accept: this.acceptAlert,
                                                    acceptText: "Accepter",
                                                    cancelText: "Annuler",
                                                    cancel: this.cancelAlert(indextr)
                                                });
                                            } else {
                                                this.commandes[indextr].valide = true;
                                                if (indextr == this.commandes.length - 1) {
                                                    this.commandes.push({
                                                        code: "",
                                                        designation: "",
                                                        qte: "",
                                                        prix: "",
                                                        totale: "",
                                                        disabled: true,
                                                        valide: false
                                                    });
                                                }
                                                // this.$refs["Recherche"].$el.querySelector('input').focus()
                                                this.$refs.Recherche.$el.focus();
                                                if (this.$store.state.AppActiveUser.username == 'cogepha')
                                                    this.$vs.notify({
                                                        time: 10000,
                                                        title: response.data.Quantity_available + " Unitées disponibles",
                                                        text: "Vous avez commander " +
                                                            this.commandes[indextr].qte +
                                                            " de l'article " +
                                                            this.commandes[indextr].designation,
                                                        color: "primary",
                                                        iconPack: "feather",
                                                        icon: "icon-check",
                                                        position: "top-right"
                                                    });
                                                else
                                                    this.$vs.notify({
                                                        time: 10000,
                                                        title: "Quantité disponible",
                                                        text: "Vous avez commander " +
                                                            this.commandes[indextr].qte +
                                                            " de l'article " +
                                                            this.commandes[indextr].designation,
                                                        color: "primary",
                                                        iconPack: "feather",
                                                        icon: "icon-check",
                                                        position: "top-right"
                                                    });
                                                var unitesGratuits = (this.commandes[indextr].qte / response.data.Sales_threshold) * response.data.Free_Sales_Qty;
                                                if (unitesGratuits > response.data.Promotion_Inventory) {
                                                    unitesGratuits = response.data.Promotion_Inventory
                                                }
                                                this.$vs.dialog({
                                                    color: 'primary',
                                                    title: `Promotion`,
                                                    text: 'vous avez bénéficié de ' + Math.floor(unitesGratuits) + ' Unitée(s) gratuite(s) (' + response.data.Sales_threshold + " ---> " + response.data.Free_Sales_Qty + ")",
                                                    acceptText: "Accepter",
                                                    cancelText: "Annuler",
                                                })
                                            }
                                        } else {
                                            this.commandes[indextr].valide = true;
                                            if (indextr == this.commandes.length - 1) {
                                                this.commandes.push({
                                                    code: "",
                                                    designation: "",
                                                    qte: "",
                                                    prix: "",
                                                    totale: "",
                                                    disabled: true,
                                                    valide: false
                                                });
                                            }
                                            // this.$refs["Recherche"].$el.querySelector('input').focus()
                                            this.$refs["Recherche"].$el.querySelector("input").focus();
                                            if (this.$store.state.AppActiveUser.username == 'cogepha')
                                                this.$vs.notify({
                                                    time: 10000,
                                                    title: response.data.Quantity_available + " Unitées disponibles",
                                                    text: "Vous avez commander " + this.commandes[indextr].qte + " de l'article " + this.commandes[indextr].designation,
                                                    color: "primary",
                                                    iconPack: "feather",
                                                    icon: "icon-check",
                                                    position: "top-right"
                                                });
                                            else
                                                this.$vs.notify({
                                                    time: 10000,
                                                    title: "Quantité disponible",
                                                    text: "Vous avez commander " + this.commandes[indextr].qte + " de l'article " + this.commandes[indextr].designation,
                                                    color: "primary",
                                                    iconPack: "feather",
                                                    icon: "icon-check",
                                                    position: "top-right"
                                                });
                                        }
                                    } else {
                                        if (this.$store.state.AppActiveUser.username == 'cogepha') {
                                            this.commandes[indextr].valide = false;
                                            this.$vs.notify({
                                                time: 10000,
                                                title: response.data.Quantity_available + " Unitées disponibles",
                                                text: "Vous pouvez pas commander " + this.commandes[indextr].qte + " de l'article " + this.commandes[indextr].designation,
                                                color: "danger",
                                                iconPack: "feather",
                                                icon: "icon-alert-circles"
                                            });
                                        } else {
                                            this.commandes[indextr].valide = false;
                                            this.$vs.notify({
                                                time: 10000,
                                                title: " Quantité indisponible",
                                                text: "Vous pouvez pas commander " + this.commandes[indextr].qte + " de l'article " + this.commandes[indextr].designation,
                                                color: "danger",
                                                iconPack: "feather",
                                                icon: "icon-alert-circles"
                                            });
                                        }
                                    }
                                } else {
                                    this.$refs["Recherche"].$el.querySelector("input").focus();
                                    this.commandes[indextr].valide = false;
                                    this.$vs.notify({
                                        time: 10000,
                                        title: "Quantité indisponible !",
                                        text: "stock 0",
                                        color: "danger",
                                        iconPack: "feather",
                                        icon: "icon-alert-circles",
                                        position: "top-left"
                                    });
                                }
                                this.SelectedRow = this.commandes.length - 1;
                            } else {
                                this.$vs.loading.close();
                                this.$vs.notify({
                                    time: 10000,
                                    title: "Erreur s'est produit lors de la validation article !",
                                    text: response.data,
                                    color: "danger",
                                    iconPack: "feather",
                                    icon: "icon-alert-circles"
                                });
                            }
                        } catch {
                            this.commandes[indextr].valide = false;
                            this.$vs.notify({
                                time: 10000,
                                title: "Erreur ",
                                text: "Erreur s'est produite",
                                color: "danger",
                                iconPack: "feather",
                                icon: "icon-alert-circles"
                            });
                        }
                        if (this.commandes[indextr].prix != "")
                            this.commandes[indextr].totale =
                            (parseFloat(this.commandes[indextr].prix.toString().replace(",", ".")) * parseFloat(this.commandes[indextr].qte)).toFixed(3);
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            time: 10000,
                            title: "Erreur s'est produit lors de la validation article !",
                            text: error.response.data,
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-alert-circles"
                        });

                    });
            }
        },
        acceptAlert: function () {
            this.commandes[this.SelectedRow - 1].qte = "" + 0;
            this.$nextTick(function () {
                this.$refs["qte"][this.SelectedRow - 1].$el.querySelector("input").focus();
            })
        },
        cancelAlert: function (indextr) {
            // console.log(indextr)
            this.commandes[this.SelectedRow].valide = true;
            // if ((!this.commandes[this.commandes.length - 1].disabled) || (this.commandes[this.commandes.length - 1].valide)) {
            if (indextr == this.commandes.length - 1) {
                this.commandes.push({
                    code: "",
                    designation: "",
                    qte: "",
                    prix: "",
                    totale: "",
                    disabled: true,
                    valide: false
                });
            }
            // this.$nextTick(function () {
            //     this.$refs.Recherche.$el.focus();
            // })
            // this.$refs.Recherche.$el.focus();
            this.SelectedRow = this.commandes.length - 1;
            this.$vs.notify({
                time: 10000,
                title: "Quantité disponible",
                text: "Vous avez commander " + this.commandes[this.SelectedRow].qte + " de l'article " + this.commandes[this.SelectedRow].designation,
                color: "primary",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right"
            });
             this.$nextTick(function () {
                    this.$refs["Recherche"].$el.querySelector("input").focus();
            })
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridColumnApi = this.gridOptions.columnApi;
        // this.gridApi = this.gridOptions.api;
        // if (this.$vs.rtl) {
        //     const header = this.$refs.agGridTable.$el.querySelector(
        //         ".ag-header-container"
        //     );
        //     header.style.left =
        //         "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
        // }
    },
    created() {
        // this.$vs.loading()
        console.log("vue ",this.$store.state.AppActiveUser.id)
        this.$store.dispatch('TOGGLEREDUCEBUTTON', true);
        this.LoadDateSession();
        if (this.$store.state.AppActiveUser.id != 0) {
           // this.LoadData();
        }
        this.$store.subscribe(mutation => {
            if (mutation.type === "UPDATE_USER_INFO") {
                //this.LoadData();
            }
        });
    },
    destroyed() {
        this.$store.dispatch('TOGGLEREDUCEBUTTON', false);
    }
};
</script>

<style lang="scss">
.ag-theme-material {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    // font-family: "Trebuchet MS", Arial, Tahoma, Serif;
    // font-family: "Avenir", Helvetica, Arial, sans-serif;
}

// .ag-theme-material .ag-row {
//     border-style: solid;
//     border-color: #000000;
//     border-width: 2;
// }

// .ag-header-cell-label {
//     /* Necessary to allow for text to grow vertically */
//     height: 10%;
//     padding: 50 !important;
// }

.ag-theme-material .ag-header {
    // border-style: solid;
    // font-family: 'Avenir', Helvetica, Arial, sans-serif;
    // border-color: #000000;
    background: #002b5c;
    color: white;
    // height: 10px;
    // font-size: 20%;
    // height: 48px;
    // border-width: 0;
}

.ag-row-hover {
    /* putting in !important so it overrides the theme's styling as it hovers the row also */
    background-color: #dfdfff !important;
}

#teleCommande {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        border-color: #000000;
        border-block-color: #000000;
        // padding: 0 1rem;

        .EditableField {
            color: green;
        }

        .EditableField:focus {
            outline: none !important;
            border: 1px solid #002b5c;
            box-shadow: 0 0 20px #719ECE;
        }

        tr {
            box-shadow: 0 px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        th,
        td:not(.different) {
            border: 1px solid #ddd;
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        margin-bottom: 10px;
    }

    #app pre.selected {
        margin: 8px 0;
        height: 295px;
        overflow-x: scroll;
        overflow-y: scroll;
        border: 1px solid #cde;
        border-radius: 4px;
    }

    #app .v-model-event {
        background-color: white;
        border: 1px solid #cde;
        border-radius: 4px;
    }

    #app .v-model-event.selected {
        color: red;
    }

    #app .v-model-event:hover {
        border: 1px solid #2874D5;
        background-color: #2874D5;
        color: white;
    }

    #app .vue-simple-suggest .suggest-item .text {
        display: inline-block;
        line-height: 1;
        vertical-align: text-bottom;
        overflow: hidden;
        max-width: 72%;
        text-overflow: ellipsis;
    }

    #app .vue-simple-suggest .suggest-item .text span {
        white-space: nowrap;
    }

    #app .vue-simple-suggest .suggest-item button {
        float: right;
        line-height: 1;
        margin-left: 4px;
    }

    .vue-simple-suggest-enter-active.suggestions,
    .vue-simple-suggest-leave-active.suggestions {
        transition: opacity .2s;
    }

    .vue-simple-suggest-enter.suggestions,
    .vue-simple-suggest-leave-to.suggestions {
        opacity: 0 !important;
    }
}
</style>
